import React, { useState } from 'react';

/**
 * Modal reutilizável para seleção de favorecido.
 *
 * Props:
 *  - show             {boolean}   controla a visibilidade do modal
 *  - favorecidos      {Array}     lista de favorecidos disponíveis
 *  - selectedCpfOrCnpj {string}  CPF/CNPJ do favorecido atualmente selecionado
 *  - onSelect         {Function}  chamada com o objeto favorecido ao clicar em uma linha
 *  - onClose          {Function}  chamada ao fechar o modal
 */
function FavorecidoPicker({ show, favorecidos = [], selectedCpfOrCnpj, onSelect, onClose }) {
  const [search, setSearch] = useState('');

  if (!show) return null;

  const filtered = favorecidos
    .filter(f =>
      f.nome.toLowerCase().includes(search.toLowerCase()) ||
      f.cpfOrCnpj.includes(search)
    )
    .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));

  function handleSelect(f) {
    onSelect(f);
    setSearch('');
  }

  function handleClose() {
    setSearch('');
    onClose();
  }

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 1065,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        className="modal-content"
        style={{
          width: '90%',
          maxWidth: 620,
          height: 500,
          minHeight: 500,
          maxHeight: 500,
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 6,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
          <h6 className="modal-title mb-0 small">
            <i className="bi bi-person-check me-2"></i>SELECIONAR FAVORECIDO
          </h6>
          <button type="button" className="btn-close btn-close-white" onClick={handleClose} />
        </div>

        {/* Body */}
        <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', padding: '1rem' }}>
          {/* Campo de busca */}
          <div className="mb-3">
            <label className="form-label small fw-semibold text-muted">
              <i className="bi bi-search me-1"></i>BUSCAR
            </label>
            <input
              autoFocus
              type="text"
              className="form-control form-control-sm"
              placeholder="Buscar por nome ou CPF/CNPJ..."
              value={search}
              onChange={e => setSearch(e.target.value)}
            />
          </div>

          {/* Tabela de resultados */}
          <div className="border rounded" style={{ overflowY: 'auto', flex: 1 }}>
            <table className="table table-hover table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="small">Nome</th>
                  <th className="small">CPF/CNPJ</th>
                  <th className="small">Tipo</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(f => (
                  <tr
                    key={f.cpfOrCnpj}
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleSelect(f)}
                    className={selectedCpfOrCnpj === f.cpfOrCnpj ? 'table-success' : ''}
                  >
                    <td className="small">{f.nome}</td>
                    <td className="small">{f.cpfOrCnpj}</td>
                    <td className="small">{f.tipo}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr>
                    <td colSpan={3} className="text-center text-muted small py-3">
                      <i className="bi bi-inbox me-2"></i>Nenhum favorecido encontrado.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer */}
        <div className="modal-footer" style={{ padding: '0.4rem 1rem' }}>
          <span className="text-muted small me-auto">
            {filtered.length} registro{filtered.length !== 1 ? 's' : ''} encontrado{filtered.length !== 1 ? 's' : ''}
          </span>
          <button type="button" className="btn btn-secondary btn-sm" onClick={handleClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
}

export default FavorecidoPicker;
